import { FaExpandArrowsAlt, FaTrophy, FaRocket } from 'react-icons/fa';

const ourMission = {
    sub: "Our Mission",
    heading: "Innovating AI & IT Startups",
    content: "Our mission is to provide cutting-edge AI and IT solutions that help startups thrive in a competitive digital world through innovation, scalability, and top-tier support.",
    points: [
        {
            id: 1,
            icon: <FaExpandArrowsAlt />, // Expand Arrow icon
            title: 'Delivering Scalable Solutions',
            content: 'Our AI and IT services are designed to grow with your business.',
        },
        {
            id: 2,
            icon: <FaTrophy />, // Trophy icon
            title: 'Commitment to Excellence',
            content: 'We are dedicated to providing the highest quality of service.',
        },
        {
            id: 3,
            icon: <FaRocket />, // Rocket icon
            title: 'Driving Digital Transformation',
            content: 'We empower startups with cutting-edge technology.',
        },
    ]
}

export default ourMission;